import Vue from 'vue'
import { Notification } from 'element-ui'
import Cookies from 'js-cookie'
import _ from 'lodash'
import { InboundTypeValue } from '@/api/biz/bizEnum'
import { moveNotifyToFullscreen } from '@/api/utils/message.js'
// window global var: 只有大量使用，方便书写使用时，可以定义成window全局变量
// window.$notify = Notification
// vue global var
let a = 10
export default {
  install () {
    Vue.prototype.$a = a
  }
}
export const mainVm = window.mainVm

// 定制化$notify.error $notify.error约定：停止当前线程
let notificationErrorFunc = Notification.error
Notification.error = function (message,config) {
  notificationErrorFunc(message)
  moveNotifyToFullscreen()
  console.log(message)
  if (config && config.hasOwnProperty('ternimal') && !config.ternimal) {
    return;
  }
  throw new Error(`$notify.error ternimal current thread ${message}`)
}

// 全屏时将 success/info/warning 通知也迁移到全屏容器内
;['success', 'info', 'warning'].forEach(type => {
  const originFunc = Notification[type]
  Notification[type] = function (options) {
    const result = originFunc(options)
    moveNotifyToFullscreen()
    return result
  }
})
export const $notify = Notification
export const getCookieInfo = (key) => {
  if (document.cookie.length > 0) {
    // 这里显示的格式需要切割一下自己可输出看下
    var arr = document.cookie.split('; ')
    for (var i = 0; i < arr.length; i++) {
      // 再次切割
      var arr2 = arr[i].split('=')
      // 判断查找相对应的值
      if (arr2[0] === key) {
        // 保存到保存数据的地方
        return arr2[1]
      }
    }
  }
}
// 用户信息：普通对象，从 cookie 初始化（保持原有语义，_.isEmpty/Object.keys 可正常判断）。
// 单一来源仍是 Vuex：启动时 flushUserInfoFromCookie 把同一份刷进 state.appStore.userInfo，
// 之后二者由 syncUserInfo 保持同步（写 userInfo 时一并写 Vuex），micro-app mixin 从 Vuex 取。
// 之所以不用 Proxy 代理到 Vuex：Proxy over {} 没有 own keys，会让路由守卫里的
// `_.isEmpty(userInfo)` 恒为 true，从而 window.location.reload 死循环（已踩坑）。
function getStore() {
  try { return require('@/store/store.js').default } catch (e) { return null }
}
// 用户信息的 cookie 字段集中在 @/utils/userInfoCookie 里维护（唯一定义处，供 global + Vuex + 子应用共用）
// 注意：必须先 import 建立本模块内的局部绑定，才能在下方直接调用；
// `export { x } from '...'` 只转发绑定、不在本模块创建局部变量，直接调用会 ReferenceError。
import { readUserInfoFromCookie } from '@/utils/userInfoCookie'
export { readUserInfoFromCookie }
export const userInfo = readUserInfoFromCookie()
// 更新 userInfo 的同时同步进 Vuex（供 micro-app 下发 / 组件响应式读取）
export function syncUserInfo(patch) {
  Object.assign(userInfo, patch || {})
  const store = getStore()
  if (store) store.commit('SET_USER_INFO', { ...userInfo })
}
export const routerule = {
  value: userInfo.orgNo + ',' + userInfo.distributeNo + ',' + userInfo.warehouseNo
}
export const wareHouseInfo = {
  orgNo: userInfo.orgNo,
  distributeNo: userInfo.distributeNo,
  warehouseNo: userInfo.warehouseNo
}



export const domain = () => {
  return Cookies.get('lwms.top.domain')
}

export const isCustomGoodsSKU = goodsNo => {
  if (_.isEmpty(goodsNo)) {
    return false
  }
  if (!_.startsWith(goodsNo, 'SKU')) {
    return false
  }
  if (goodsNo.length !== 15) {
    return false
  }
  return true
}

export const isBoxRuleCode = boxRuleCode => {
  if (_.isEmpty(boxRuleCode)) {
    return false
  }
  if (!_.startsWith(boxRuleCode, 'SPEC')) {
    return false
  }
  return true
}

export const isUniqueBoxNo = uniqueBoxNo => {
  if (_.isEmpty(uniqueBoxNo)) {
    return false
  }
  if (!_.startsWith(uniqueBoxNo, 'UBOX' + userInfo.warehouseNo)) {
    return false
  }
  // if (uniqueBoxNo.length !== 27) {
  //   return false
  // }
  return true
}

export const checkBizCapability = (inboundType, bizTag, ownerMark)=>{
  if(inboundType !== InboundTypeValue.Normal){
    return false
  }
  if(!bizTag || _.isEmpty(ownerMark)){
    return false
  }
  // if(bizTag.indexOf(code) != -1){
  //   return true
  // }

  if(bizTag.length >= ownerMark.index && bizTag.charAt(ownerMark.index - 1) === ownerMark.value) {
    return true
  }
  return false
}

// 换单快捷码
export const CHANGE_ORDER_CODE='change order'
